const suiteImgValue = {
  1: 'https://resource.rcclchina.com.cn/cruiseDetail/suite/suite-sea.png',
  2: 'https://resource.rcclchina.com.cn/cruiseDetail/suite/suite-sky.png',
  3: 'https://resource.rcclchina.com.cn/cruiseDetail/suite/suite-star.png'
}
const suiteTagImgValue = {
  1: 'https://resource.rcclchina.com.cn/cruiseDetail/suite/suite-tag-sea.png',
  2: 'https://resource.rcclchina.com.cn/cruiseDetail/suite/suite-tag-sky.png',
  3: 'https://resource.rcclchina.com.cn/cruiseDetail/suite/suite-tag-star.png'
}
export default {
  suiteImgValue,
  suiteTagImgValue
}
